var App = App || {};

App.SectionTabs = (() => {
    'use strict';

    const init = (selector) => {
        if (selector) {
            const sections = selector instanceof Element ? [selector] : document.querySelectorAll(selector);

            sections.forEach(section => {
                const select = section.querySelector('.form-select');

                if (select) {
                    select.addEventListener('change', () => {
                        const activeTab = section.querySelector(`[data-bs-target="${select.value}"]`);
                        if (activeTab && bootstrap) {
                            const tab = new bootstrap.Tab(activeTab);
                            tab.show();
                        }
                    });

                    section.addEventListener('shown.bs.tab', (e) => {
                        const activeTab = section.querySelector('[data-bs-toggle="tab"].active')?.getAttribute('data-bs-target');
                        if (activeTab) {
                            select.value = activeTab;
                        }
                    });
                }
            });
        }
    }

    return {
        init
    };
})();